fragment LeadDistributionAutomation on LeadDistributionAutomation {
    id
    conditions {
        config {
            ... on ConditionConfigEntityFilter {
                filter {
                    fieldName
                    fieldType
                    ... on EntityFilterFieldConfigBoolean {
                        booleanValue
                    }
                    ... on EntityFilterFieldConfigCurrency {
                        currencyValue
                        currencyComparator
                        currencyCode
                    }
                    ... on EntityFilterFieldConfigRelationship {
                        fieldName
                        relationshipData
                    }
                }
            }

            ... on ConditionConfigLink {
                links
            }
        }
    }
}
